'use strict';

import controller from './lista-convenio.controller';
import template from './lista-convenio.html';

const listConvComponent = {
	binding: {},
	controller,
	template
};

export default listConvComponent;


// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/bandeja/lista-convenios-reporte/lista-convenio.component.js